import React from 'react';
import { FadeIn } from './FadeIn';
export function Story() {
  return <section className="py-20 md:py-24 px-6 bg-cream-dark/30" data-id="element-104" data-mp="1icf86slelj2c">
      <div className="max-w-reading mx-auto" data-id="element-105" data-mp="1iauef56wy45j">
        <FadeIn data-id="element-106" data-mp="1n3dse39ij1av">
          <div className="flex items-center gap-4 mb-12" data-id="element-107" data-mp="1n2vkg9dhmyn4">
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-108" data-mp="1n5hssb87di6e">
              My Story
            </h2>
            <div className="h-px flex-grow bg-amber/30 mt-2" data-id="element-109" data-mp="ueq2tvhqdpri" />
          </div>
        </FadeIn>

        <div className="space-y-6 md:space-y-8 text-base md:text-xl text-charcoal/80 leading-relaxed font-light" data-id="element-110" data-mp="zdb0bn5llvc9">
          <FadeIn delay={0.1} data-id="element-111" data-mp="14ce7pe91wdne">
            <p data-id="element-112" data-mp="14b2tsllw5pik">
              I've always been the kind of person who wants to know how things
              actually work — not just the surface answer, but the reasoning
              underneath. That's a big part of why the legal field has always
              pulled at me. Law is basically the operating system of how people,
              businesses, and societies make decisions, and I find that
              fascinating.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-113" data-mp="142p5yp92zqgh">
            <p data-id="element-114" data-mp="143i5b55pndol">
              Right now I'm enrolled in the UCLA Paralegal Training Program,
              which has been a great way to actually dig into the practical side
              of things — civil litigation, contracts, legal research, and a lot
              of writing. It's structured, demanding, and exactly the kind of
              environment I wanted to be in.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-115" data-mp="lb64imupgkgk">
            <blockquote className="my-8 md:my-12 pl-5 md:pl-10 border-l-2 border-amber py-2" data-id="element-116" data-mp="gd4lu316yn5m">
              <p className="font-playfair text-xl md:text-3xl text-charcoal italic leading-snug" data-id="element-117" data-mp="beb94ctqb06i">
                "I'd rather do the work right than do it fast — but ideally,
                both."
              </p>
            </blockquote>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-118" data-mp="2e4wet5uu48e">
            <p data-id="element-119" data-mp="2fz9xmesqu2g">
              I'm at the start of this career, but I'm not at the start of
              caring about doing things well. I've spent years getting good at
              showing up prepared, paying attention to the details other people
              miss, and being someone a team can actually count on. I'm looking
              for the right place to put those habits to work.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}